import type {SessionTask, SetActiveNavigate} from '@clerk/shared/types'
import {getSafeRedirectUrl} from '@fitro/customer-features/lib/safeRedirectUrl'

export const clerkTaskUrls: Record<SessionTask['key'], string> = {
    'choose-organization': '/tasks/choose-organization',
    'reset-password': '/tasks/reset-password',
    'setup-mfa': '/tasks/setup-mfa',
}

const clerkTaskCompletionUrl = '/tasks/complete'

function withTaskRedirect(taskUrl: string, redirectUrl: string): string {
    const params = new URLSearchParams({redirect_url: redirectUrl})
    return `${taskUrl}?${params.toString()}`
}

export function getClerkTaskCompletionUrl(value: string | null | undefined, fallback: string): string {
    return getSafeRedirectUrl(value, fallback)
}

export function getClerkTaskCompletionBounceUrl(value: string | null | undefined, fallback: string): string {
    const redirectUrl = getClerkTaskCompletionUrl(value, fallback)
    const params = new URLSearchParams({redirect_url: redirectUrl})
    return `${clerkTaskCompletionUrl}?${params.toString()}`
}

export function getClerkTaskDestination(task: SessionTask | null | undefined, redirectUrl: string): string {
    return task
        ? withTaskRedirect(clerkTaskUrls[task.key] ?? redirectUrl, redirectUrl)
        : redirectUrl
}

export function createClerkTaskNavigate(redirectUrl: string): SetActiveNavigate {
    return ({decorateUrl, session}) => {
        const destination = getClerkTaskDestination(session.currentTask, redirectUrl)
        window.location.assign(decorateUrl(destination))
    }
}
